import { WEBCOIN_SECTIONS } from '@wwe-portal/web/utils/constants/webcoin';
import { useTranslations } from 'next-intl';
import RefreshTimer from '../refresh-timer/refresh-timer';
import { Each } from '@wwe-portal/ui/components/utils';
import { Frame } from '@wwe-portal/entities/webcoin.type';
import { AlternativePurchaseTypes } from '@wwe-portal/web/services/payment/type';
import WebCoinShopCard from '../web-coin-shop-card/web-coin-shop-card';

export const AvatarFrameListDesktop = ({
  ref,
  pacificDate,
  handleUpdateLiveList,
  framesList,
  handleItemsPurchase,
  purchasingOffer,
}: {
  ref: React.RefObject<HTMLDivElement | null>;
  pacificDate: string;
  handleUpdateLiveList: () => void;
  framesList: Frame[];
  handleItemsPurchase: ({ price, itemId, type, title }) => void;
  purchasingOffer: any;
}) => {
  const t = useTranslations();

  return (
    <div id={WEBCOIN_SECTIONS.AVATAR_FRAMES}>
      <div
        ref={ref}
        className="shop-featured mb-[10px] flex justify-between pt-[30px]"
      >
        <div className="mb-0 text-xl font-semibold">{t('avatar_frames')}</div>
        {pacificDate && (
          <RefreshTimer
            time={pacificDate}
            handleTimerFromChild={handleUpdateLiveList}
          />
        )}
      </div>
      <p className="text-text600 mb-8 text-xs">
        {t('avatar_frames_description')}
      </p>
      <div className="-mr-[10px] flex flex-wrap justify-start">
        <Each
          data={framesList}
          render={(item: Frame, index) => (
            <div
              key={index}
              className="3xl:basis-1/5 mb-[30px] pr-4 md:basis-1/3"
            >
              <WebCoinShopCard
                title={item.displayName || 'Avatar'}
                rarity={item.rarity}
                image={item.image}
                price={item.price}
                id={item.frameId}
                unlocked={item.unlocked}
                handlePurchaseClick={(price, itemId, type) =>
                  handleItemsPurchase({
                    price,
                    itemId,
                    type,
                    title: item.displayName,
                  })
                }
                index={index}
                listType={AlternativePurchaseTypes.Frame}
                paymentLoading={purchasingOffer?.offerId === item.frameId}
              />
            </div>
          )}
        />
      </div>
    </div>
  );
};
